var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatalog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.602,
    height: 19.34,
    viewBox: "0 0 20.602 19.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "catalog",
    transform: "translate(-101.706 -47.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_40",
    "data-name": "Union 40",
    d: "M-9469.459-6024.312h-15.557a1.854,1.854,0,0,1-1.679-1.9v-14.159a1.579,1.579,0,0,1,1.679-1.583h.012v-.133a1.55,1.55,0,0,1,1.677-1.557h3.647l.138,0a1.264,1.264,0,0,1,1.06.34l1.523,1.614a.482.482,0,0,0,.348.157h8.84a1.712,1.712,0,0,1,1.679,1.74v11.866a1.711,1.711,0,0,1-1.676,1.74h-.015a2.05,2.05,0,0,1-.848,1.614l.139.262Zm-16.068-16.059v14.159c0,.378.288.733.512.733h15.557c.222,0,.51-.355.51-.736v-11.864a.548.548,0,0,0-.51-.576h-8.843a1.661,1.661,0,0,1-1.2-.521l-1.515-1.607a.926.926,0,0,0-.138-.007l-.219,0h-3.646C-9485.208-6040.788-9485.527-6040.736-9485.527-6040.372Zm17.759,13.019a.548.548,0,0,0,.51-.576V-6039.8a.548.548,0,0,0-.513-.576h-8.84a1.664,1.664,0,0,1-1.2-.521l-1.5-1.593a1.715,1.715,0,0,0-.186,0c-.058,0-.119,0-.186,0h-3.647c-.339,0-.51.131-.51.391v.133h2.467l.219,0a1.275,1.275,0,0,1,.979.364l1.523,1.617a.479.479,0,0,0,.348.155h8.843a1.713,1.713,0,0,1,1.676,1.743v10.726Z",
    transform: "translate(9588.4 6091.4)",
    fill: "#bebfb6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalog);
export default __webpack_public_path__ + "static/media/catalog.a76f8e1d8add19f69ff94650cbf760b2.svg";
export { ForwardRef as ReactComponent };